import React from 'react';
import ReactDOM from 'react-dom';

import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { ROUTER_BASENAME } from 'utils';

import App from './views/App';

import initStore from './store';

const preloadedState = window.__PRELOADED_STATE__; //eslint-disable-line

delete window.__PRELOADED_STATE__; //eslint-disable-line

const customMiddleware = [];
if (process.env.NODE_ENV === `development`) {
  const logger = require(`redux-logger`).createLogger({ // eslint-disable-line
    collapsed: true,
  });

  customMiddleware.push(logger);
}

if (`scrollRestoration` in window.history) {
  window.history.scrollRestoration = `manual`;
}


const store = initStore(preloadedState, customMiddleware);

ReactDOM.hydrate(
  <Provider store={ store }>
    <Router basename={ROUTER_BASENAME}>
      <App />
    </Router>
  </Provider>,
  document.getElementById(`root`),
);


/* eslint-disable */
window.fbAsyncInit = function () {
  FB.init({
    appId: process.env.API_ENV === `production` ? '589253514514371' : '1359700854145270',
    xfbml: true,
    version: 'v3.3',
  });
  FB.getLoginStatus(function (response) {
    window.fbApiInit = true;
  });
};

/* eslint-enable */

/* eslint-disable */

//load the gmail login stuff
((d, s, id, cb) => {
  const element = d.getElementsByTagName(s)[0];
  const fjs = element;
  let js = element;
  js = d.createElement(s);
  js.id = id;
  js.src = '//apis.google.com/js/client:platform.js';
  fjs.parentNode.insertBefore(js, fjs);
  js.onload = cb;
})(document, 'script', 'google-login', () => {
  window.gapi.load('auth2', () => {
    if (!window.gapi.auth2.getAuthInstance()) {
      window.gapi.auth2.init({
        client_id: "764020607148-e0iabr6v5npa5k6jja7ui8pgkq808l2q.apps.googleusercontent.com",
        cookiepolicy: 'single_host_origin',
        fetchBasicProfile: true,
        scope: 'profile email',
      });
    }
  });
});
/* eslint-enable */

/* eslint-disable */
//load the JavaScript SDK asynchronously
(function(d, s, id) {
  var js, fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) { return; }
  js = d.createElement(s); js.id = id;
  js.src = "//connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));
/* eslint-enable */
